module.exports = __webpack_public_path__ + "img/accordion-expanded.a1e54330.svg";